function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import subtleAlgorithm from './subtle_rsaes.js';
import bogusWebCrypto from './bogus.js';
import crypto, { isCryptoKey } from './webcrypto.js';
import { checkEncCryptoKey } from '../lib/crypto_key.js';
import checkKeyLength from './check_key_length.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import { types } from './is_key_like.js';
export var encrypt = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(alg, key, cek) {
    var _crypto$subtle, cryptoKeyCek, _t, _t2, _t3, _t4;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (isCryptoKey(key)) {
            _context.n = 1;
            break;
          }
          throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types))));
        case 1:
          checkEncCryptoKey(key, alg, 'encrypt', 'wrapKey');
          checkKeyLength(alg, key);
          if (!key.usages.includes('encrypt')) {
            _context.n = 3;
            break;
          }
          _t = Uint8Array;
          _context.n = 2;
          return crypto.subtle.encrypt(subtleAlgorithm(alg), key, cek);
        case 2:
          _t2 = _context.v;
          return _context.a(2, new _t(_t2));
        case 3:
          if (!key.usages.includes('wrapKey')) {
            _context.n = 6;
            break;
          }
          _context.n = 4;
          return (_crypto$subtle = crypto.subtle).importKey.apply(_crypto$subtle, ['raw', cek].concat(_toConsumableArray(bogusWebCrypto)));
        case 4:
          cryptoKeyCek = _context.v;
          _t3 = Uint8Array;
          _context.n = 5;
          return crypto.subtle.wrapKey('raw', cryptoKeyCek, key, subtleAlgorithm(alg));
        case 5:
          _t4 = _context.v;
          return _context.a(2, new _t3(_t4));
        case 6:
          throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');
        case 7:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function encrypt(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var decrypt = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(alg, key, encryptedKey) {
    var _crypto$subtle2, cryptoKeyCek, _t5, _t6, _t7, _t8;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          if (isCryptoKey(key)) {
            _context2.n = 1;
            break;
          }
          throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types))));
        case 1:
          checkEncCryptoKey(key, alg, 'decrypt', 'unwrapKey');
          checkKeyLength(alg, key);
          if (!key.usages.includes('decrypt')) {
            _context2.n = 3;
            break;
          }
          _t5 = Uint8Array;
          _context2.n = 2;
          return crypto.subtle.decrypt(subtleAlgorithm(alg), key, encryptedKey);
        case 2:
          _t6 = _context2.v;
          return _context2.a(2, new _t5(_t6));
        case 3:
          if (!key.usages.includes('unwrapKey')) {
            _context2.n = 6;
            break;
          }
          _context2.n = 4;
          return (_crypto$subtle2 = crypto.subtle).unwrapKey.apply(_crypto$subtle2, ['raw', encryptedKey, key, subtleAlgorithm(alg)].concat(_toConsumableArray(bogusWebCrypto)));
        case 4:
          cryptoKeyCek = _context2.v;
          _t7 = Uint8Array;
          _context2.n = 5;
          return crypto.subtle.exportKey('raw', cryptoKeyCek);
        case 5:
          _t8 = _context2.v;
          return _context2.a(2, new _t7(_t8));
        case 6:
          throw new TypeError('RSA-OAEP key "usages" must include "decrypt" or "unwrapKey" for this operation');
        case 7:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return function decrypt(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();